var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.viewFailedFilesShow,
          expression: "viewFailedFilesShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "viewFailedFiles" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("language.popup.failedFilesPopup.title", {
                  num: _vm.unfinishData.length
                })
              ) +
              "\n            "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "view-failed-files-body" }, [
          _c(
            "div",
            { staticClass: "view-failed-files-table" },
            [
              _c(
                "el-table",
                {
                  ref: "viewFailedFilesTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.unfinishData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark",
                    height: "560"
                  },
                  on: {
                    "selection-change": _vm.selectRetryFiles,
                    "header-dragend": _vm.onHeaderDragEnd
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "26" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "file",
                      label: _vm.$t("language.common.transferFiles"),
                      "min-width": "215",
                      resizable: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", {
                              staticClass: "file_size_25",
                              class: _vm.matchfileType(scope.row)
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "table-cell",
                                attrs: { title: _vm.getFileName(scope.row) }
                              },
                              [_vm._v(_vm._s(_vm.getFileName(scope.row)))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "source",
                      label: _vm.$t("language.common.sourceDir"),
                      "min-width": "380",
                      resizable: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.fromItem.driveType !== "Shares"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "table-cell",
                                    attrs: {
                                      title: _vm._f("getCatalogTitle")(
                                        _vm._f("getCatalog")(
                                          scope.row.fromItem.nodes
                                        )
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getCatalog")(
                                          scope.row.fromItem.nodes
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "table-cell",
                                    attrs: {
                                      title: _vm._f("getCatalogTitle")(
                                        _vm._f("getCatalogShare")(
                                          scope.row.fromItem.nodes
                                        )
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getCatalogShare")(
                                          scope.row.fromItem.nodes
                                        )
                                      )
                                    )
                                  ]
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "size",
                      label: _vm.$t("language.common.size"),
                      "min-width": "90",
                      resizable: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.filesize
                              ? _c("div", { staticClass: "table-cell" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatLogByte")(
                                        scope.row.filesize
                                      )
                                    )
                                  )
                                ])
                              : _c("div", { staticClass: "table-cell" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatLogByte")(scope.row.size)
                                    )
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "reason",
                      label: _vm.$t("language.common.failureReason"),
                      "min-width": "400",
                      resizable: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.cause
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "table-cell",
                                    attrs: {
                                      title: _vm._f("getCauseReason")(
                                        scope.row.cause
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getCauseReason")(
                                          scope.row.cause
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "table-cell",
                                    attrs: {
                                      title: _vm._f("getCauseReason")(
                                        scope.row.exception
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("getCauseReason")(
                                          scope.row.exception
                                        )
                                      )
                                    )
                                  ]
                                )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "0" },
                  attrs: {
                    id: "viewFailedFilesData",
                    data: _vm.stringifiedItems,
                    height: "0"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "file" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getFileName(scope.row)) +
                                "\n                        "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "source", "min-width": "400" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.fromItem.driveType !== "Shares"
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCatalog")(
                                        scope.row.fromItem.nodes
                                      )
                                    )
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCatalogShare")(
                                        scope.row.fromItem.nodes
                                      )
                                    )
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "size", "min-width": "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.filesize
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatLogByte")(
                                        scope.row.filesize
                                      )
                                    )
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatLogByte")(scope.row.size)
                                    )
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "reason", "min-width": "420" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.cause
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCauseReason")(scope.row.cause)
                                    )
                                  )
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCauseReason")(
                                        scope.row.exception
                                      )
                                    )
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "view-failed-files-btns" }, [
            _c(
              "div",
              {
                staticClass: "view-failed-files-tip",
                on: {
                  click: function($event) {
                    return _vm.jumpToLimitations()
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    on: {
                      mouseout: function($event) {
                        _vm.tipShow = false
                      },
                      mouseover: function($event) {
                        _vm.tipShow = true
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass:
                        "icon-util question-mark question-mark-position"
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("language.popup.limits")) +
                      "\n                    "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _vm.stringifiedItems.length > 0
                ? _c(
                    "button",
                    {
                      staticStyle: { float: "left", "margin-right": "32px" },
                      on: {
                        click: function($event) {
                          return _vm.exportExcel()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t(
                              "language.popup.failedFilesPopup.exportExcel"
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-247d420e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-247d420e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/view_failed_files_popup.vue
// module id = null
// module chunks = 